/** Preserve the upstream explanation without rendering an HTML error page. */
export const responseError = async (response: Response, fallback: string): Promise<Error> => {
  try {
    const body = await response.json() as { detail?: unknown; error?: unknown; message?: unknown };
    const detail = body.detail ?? body.error ?? body.message;
    if (typeof detail === "string" && detail.trim()) return new Error(detail);
    if (Array.isArray(detail)) {
      const messages = detail.map((item) => typeof item?.msg === "string" ? item.msg : "").filter(Boolean);
      if (messages.length) return new Error(messages.join("; "));
    }
  } catch {
    // Empty and non-JSON responses still have a useful status and operation.
  }
  return new Error(`${fallback} (${response.status})`);
};
